import { render, staticRenderFns } from "./OperShif.vue?vue&type=template&id=c339db6a&scoped=true"
import script from "./OperShif.vue?vue&type=script&lang=js"
export * from "./OperShif.vue?vue&type=script&lang=js"
import style0 from "./OperShif.vue?vue&type=style&index=0&id=c339db6a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c339db6a",
  null
  
)

export default component.exports